import React from 'react';
import { bool } from 'prop-types';
import { IconButton } from '@one-thd/sui-atomic-components';
import { Move } from '@one-thd/sui-icons';

export const MoveIconOverlay = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div
      className={[
        'sui-absolute sui-top-1/2 sui-left-1/2',
        'sui--translate-x-1/2 sui--translate-y-1/2',
        'sui-pointer-events-none',
        'sui-bg-[#ffffff] sui-rounded-lg',
        'sui-shadow-md',
        'sui-flex sui-items-center sui-justify-center',
        'sui-w-8 sui-h-8',
        'sui-overflow-visible'
      ].join(' ')}
    >
      <IconButton
        icon={Move}
        iconSize="small"
        color="brand"
        aria-label="Drag and Move Image"
      />
    </div>
  );
};

MoveIconOverlay.propTypes = {
  isVisible: bool.isRequired,
};
